import { render, staticRenderFns } from "./BundleStatusTag.vue?vue&type=template&id=7ac132a3&"
import script from "./BundleStatusTag.vue?vue&type=script&lang=js&"
export * from "./BundleStatusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports